<template>
  <v-card>
    <v-card-title class="pb-8">
      <v-btn
        color="primary"
        @click="CHANGE_SERVIZI_COMPONENT('Insert')"
      >Nuovo Servizio</v-btn>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Cerca"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="services"
      class="elevation-1"
      :search="search"
      :items-per-page="100"
      :footer-props="{
      itemsPerPageAllText: 'Tutti',
      itemsPerPageOptions: [15, 50, 100, -1],
      itemsPerPageText: 'Servizi per pagina',
    }"
    >
      <template v-slot:top>
        <edit-form
          :item="selectedItem"
          @edit-submit="triggerSnack($event)"
        />
      </template>

      <template v-slot:item.action="{ item }">
        <v-icon
          small
          class="mr-2"
          @click="edit(item)"
        >
          mdi-pencil
        </v-icon>
      </template>

      <template v-slot:no-data>
        <v-btn
          color="primary"
          @click="fetchServices"
        >Ricarica</v-btn>
      </template>

      <template v-slot:item.price="{ item }">
        <span>{{item.price || '0'}}€</span>
      </template>
    </v-data-table>
    <snack-notification :snack="snack" />
  </v-card>
</template>

<script>
  import axios from 'axios'
  import { mapMutations } from 'vuex'

  import EditForm from './EditForm'
  import SnackNotification from './../../SnackNotification'

  export default {
    name: 'Index',
    components: {
      EditForm,
      SnackNotification
    },
    data: () => ({
      search: '',
      headers: [
        { text: 'Nome', value: 'name', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'Prezzo', value: 'price', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'Azioni', value: 'action', class: 'subtitle-2 primary--text font-weight-bold', sortable: 'false' }
      ],
      services: [],
      item: {},
      snack: {
        error: null,
        visible: null,
        message: null
      },
      config: {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
        }
      }
    }),

    computed: {
      selectedItem() {
        return this.item
      }
    },

    methods: {
      ...mapMutations([
        'CHANGE_SERVIZI_COMPONENT',
        'CHANGE_SERVIZI_EDIT'
      ]),

      async fetchServices() {
        try {

          let {
            data
          } = await axios.get(`${process.env.VUE_APP_API}/services/fetch`, this.config)

          this.services = data
        } catch (error) {

          console.log(error)

          this.services = []
        }
      },

      edit(val) {
        this.item = val
        this.CHANGE_SERVIZI_EDIT(true)
      },

      triggerSnack(e) {
        if (e === 'reset') {

          this.snack = Object.assign({}, {
            error: null,
            visible: null,
            message: null
          })
        } else if (e === 'ok') {

          this.snack = Object.assign({}, {
            visible: true,
            error: false,
            message: 'Articolo modificato correttamente!'
          })
        } else if (e === 'error') {

          this.snack = Object.assign({}, {
            visible: true,
            error: true,
            message: 'Errore nella modifica.'
          })
        }
      }
    },

    async created() {
      await this.fetchServices()
    },
  }
</script>

<style>
</style>